/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/viz/shared/models/SelectorsModel.js"/>
/// <reference path="~/js/viz/shared/routers/VizRouterBase.js"/>
/// <reference path="~/js/viz/map/config/MapConfig.js"/>

(function(_) {
  var ns, sharedNs;

  ns = window.nspace("ccc.viz.map");
  sharedNs = window.nspace("ccc.viz.shared");

  ns.MapVizRouter = sharedNs.routers.VizRouterBase.extend({
	routes: {
		"": "initializeViews",
		":indicatorId": "initializeViews",
		":indicatorId/:characteristicId": "initializeViews",
		":indicatorId/:characteristicId/:locationTypeId": "initializeViews",
		":indicatorId/:characteristicId/:locationTypeId/:dataFormatId": "initializeViews",
		":indicatorId/:characteristicId/:locationTypeId/:dataFormatId/:timeFrameId": "initializeViews",
		":indicatorId/:characteristicId/:locationTypeId/:dataFormatId/:timeFrameId/:selectedFips": "initializeViews",
		":indicatorId/:characteristicId/:locationTypeId/:dataFormatId/:timeFrameId/:selectedFips/:overlays": "initializeViews"
	},


    /**
     * This method will only ever be invoked a single time, so use it to initialize
     * the model/view classes and trigger the initial rendering
     */
    initializeViews: function(
      indicatorId,
      characteristicId,
      locationTypeId,
      dataFormatId,
      timeFrameId,
      selectedFips,
      overlays
    ) {
      //// MODELS ////

      function getValue(raw) {
        if (typeof raw === "undefined" || raw === "a") {
          return undefined;
        }

        return raw;
      }

      // Create the selectors model, which represents anything that is selectable by the user and tracked in the URL
      this.selectorsModel = new sharedNs.models.SelectorsModel();
      this.selectorsModel.set(
        {
          indicatorId: getValue(indicatorId),
          characteristicId: getValue(characteristicId),
          locationTypeId: getValue(locationTypeId),
          dataFormatId: getValue(dataFormatId),
          timeFrameId: getValue(timeFrameId),
					selectedFips: getValue(selectedFips),
					overlays: getValue(overlays)
					},
        {
          silent: true
        }
      );

      // Create the data response model, the model that is responsible for querying the server-side for data,
      // storing the response, and triggering updates to other views after the response has been retrieved
      this.dataModel = new ns.models.DataResponseModel({
        selectorsModel: this.selectorsModel,
        dispatcher: this.dispatcher,
        dataUrl: ns.config.MapConfig.dataUrl
      });

      //// VIEWS ////

      this.views = {
        // Loading spinner (no model required)
        loadingSpinner: new sharedNs.views.LoadingSpinnerView({
          dispatcher: this.dispatcher
        }),

        // Data summary and table need both models. The SelectorsModel so that we know when a
        // new location is selected, and the DataResponseModel for rendering the data.
        selectedRegionSummaryView: new ns.views.SelectedRegionSummaryView({
          model: this.selectorsModel,
          dataResponseModel: this.dataModel
        }),

        // Same Summary view as above, but specifically for NYC
        nycSummaryView: new ns.views.NYCSummaryView({
          model: this.selectorsModel,
          dataResponseModel: this.dataModel
        }),

        // Currently selected region table view
        selectedRegionTableView: new ns.views.SelectedRegionTableView({
          model: this.selectorsModel,
          dataResponseModel: this.dataModel
        }),

        // Same Table view as above, but specifically for NYC
        nycTableView: new ns.views.NYCTableView({
          model: this.selectorsModel,
          dataResponseModel: this.dataModel
        }),

        // "Select a Region" prompt
        selectRegionPromptView: new ns.views.SelectRegionPromptView({
          model: this.selectorsModel
        }),

        // Map
        mapView: new ns.views.GoogleMapView({
          model: this.selectorsModel,
          dispatcher: this.dispatcher,
          dataResponseModel: this.dataModel
        }),

        // Legend, popups, & data tables are wired to the DataResponseModel
        legendView: new ns.views.LegendView({
          model: this.dataModel
        }),

        // Source/Definition/Notes
        sourceDefinitionNotesView: new sharedNs.views.SourceDefinitionNotesView(
          {
            selectorsModel: this.selectorsModel,
            model: this.dataModel
          }
        ),

        // Source/Definition/Notes
        overlayView: new ns.views.OverlayView({
          model: this.dataModel
        }),

        // Map popup
        mapPopupView: new ns.views.MapPopupView({
          model: this.dataModel,
          selectorsModel: this.selectorsModel,
          dispatcher: this.dispatcher
        }),

        // Selectors. These must be instantiated late, since these views are used to bootstrap
        // the selectors model values, and certain other views need to hear when the selectors model changes.
        selectorsView: new ns.views.SelectorsView({
          model: this.selectorsModel,
          indicatorGroupId: this.indicatorGroupId,
          dispatcher: this.dispatcher
        })
      };

      this.completeRouterInitialization();
    },

    routeUrlParts: function() {
      return [
        this.selectorsModel.get("indicatorId"),
        this.selectorsModel.get("characteristicId"),
        this.selectorsModel.get("locationTypeId"),
        this.selectorsModel.get("dataFormatId"),
        this.selectorsModel.get("timeFrameId"),
				this.selectorsModel.get("selectedFips"),
				this.selectorsModel.get("overlays")
      ];
    }
  });
})(_);
